import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/StartCode.css';

const StartCode = ({ userData }) => {
  const [startCode, setStartCode] = useState(['', '', '', '', '', '']);
  const [isValid, setIsValid] = useState(false);
  const inputRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null)
  ];
  const navigate = useNavigate();

  
  useEffect(() => {
    const allFilled = startCode.every(digit => /^\d$/.test(digit));
    setIsValid(allFilled);
  }, [startCode]);

  const handleChange = (index, value) => {
    
    if (!/^\d*$/.test(value)) return;

    const newCode = [...startCode];
    newCode[index] = value;
    setStartCode(newCode);

    
    if (value && index < 5) {
      inputRefs[index + 1].current.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    
    if (e.key === 'Backspace' && !startCode[index] && index > 0) {
      inputRefs[index - 1].current.focus();
    }
  };

  const handleStartTest = () => {
    
    navigate('/module/verbal/1');
  };

  return (
    <div className="start-code-container">
      <div className="start-code-content">
        <h1>Start Code</h1>
        <p className="instructions">Enter your start code now to begin testing. Good luck!</p>
        <p className="sub-instructions">The start code contains <strong>numbers only</strong>.</p>

        <div className="code-inputs">
          {startCode.map((digit, index) => (
            <input
              key={index}
              ref={inputRefs[index]}
              type="text"
              maxLength="1"
              value={digit}
              onChange={(e) => handleChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              className="code-input"
            />
          ))}
        </div>

        <button 
          className={`start-test-btn ${isValid ? 'active' : ''}`}
          onClick={handleStartTest}
          disabled={!isValid}
        >
          Start Test
        </button>
      </div>
      
      <div className="review-link">
        You can <a href="#">review the instructions</a> that the proctor reads aloud.
      </div>
    </div>
  );
};

export default StartCode;
